import { ExpandMore } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DropdownMenu, DropdownToggle, Label, UncontrolledDropdown } from "reactstrap";
import {
    drivingExemptionDetailsPathRoute,
    drivingExemptionOnBehalfRoute,
    drivingExemptionOverviewPathRoute,
    gnhDrivingExemptionBlankFormRoute,
    gnhUsersSubmittedFormListRoute,
    lvCommuteExemptionBlankFormRoute
} from "./DrivingExemptionRoutes";
import { ISelectOption } from "../forms/util";

const getLVCommuteExemptionRoute = () => { return lvCommuteExemptionBlankFormRoute; }
const getGnhDrivingExemptionFormRoute = () => { return gnhDrivingExemptionBlankFormRoute; }
const getGnhUserSubmittedFormListRoute = () => { return gnhUsersSubmittedFormListRoute; }
const getGnhOverviewPathRoute = () => { return drivingExemptionOverviewPathRoute; }
const getGnhDetailPathRoute = () => { return drivingExemptionDetailsPathRoute; }
const getGnhOnBehalfRoute = () => { return drivingExemptionOnBehalfRoute; }


export const gnhDrivingExemptionForm = {
    label: "GNH Exemption Form",
    value: "gnhDrivingExemptionForm",
    getRoute: getGnhDrivingExemptionFormRoute
} as ISelectOption;

export const gnhDrivingExemptionFormOnBehalf = {
    label: "On-behalf GNH form",
    value: "gnhDrivingExemptionFormOnBehalf",
    getRoute: getGnhOnBehalfRoute
} as ISelectOption;

export const gnhUsersSubmittedFormList = {
    label: "My Exemption",
    value: "gnhUsersSubmittedFormList",
    getRoute: getGnhUserSubmittedFormListRoute
} as ISelectOption;

export const lvCommuteExemptionForm = {
    label: "LV Commute Exemption Form",
    value: "lvCommuteExemptionForm",
    getRoute: getLVCommuteExemptionRoute
} as ISelectOption;


export const gnhAdminSummaryDashboardOverview = {
    label: "Exemptions Dashboard",
    value: "gnhAdminSummaryDashboardOverview",
    getRoute: getGnhOverviewPathRoute,
} as ISelectOption;

export const gnhUserDetails = {
    label: "Overview",
    value: "gnhUserDetails",
    getRoute: getGnhDetailPathRoute,
    subitem: true
} as ISelectOption;

interface DrivingExemptionPageSelectorProps {
    selectedPage: ISelectOption
}

export const DrivingExemptionPageSelector = (props: DrivingExemptionPageSelectorProps) => {
    const [currentSelection, setCurrentSelection] = useState(props.selectedPage);
    const [selectOptions, setSelectOptions] = useState([props.selectedPage] as ISelectOption[]);
    const navigate = useNavigate();

    const getSelectOptions = () => {
        var options: ISelectOption[] = [];

        options.push(gnhDrivingExemptionForm);
        options.push(gnhUsersSubmittedFormList);
        options.push(lvCommuteExemptionForm);
        options.push(gnhAdminSummaryDashboardOverview);
        options.push(gnhDrivingExemptionFormOnBehalf);

        return options;
    }

    const selectOnChange = (selectOption: ISelectOption) => {
        var path = selectOption.getRoute().path;
        if (selectOption !== currentSelection && typeof (path) === 'string') {
            navigate(path);
        }
    }

    useEffect(() => {
        if (currentSelection === undefined) {
            setCurrentSelection(gnhDrivingExemptionForm);
        }
    }, [selectOptions]);

    return (
        <div className="driving-exemptions-selector fa-narrow">
            <UncontrolledDropdown>
                <DropdownToggle tag="div" className="rbt-input-main form-control rbt-input">
                    <div className="de-select-options">{currentSelection.label}</div>
                </DropdownToggle>
                <ExpandMore />
                <DropdownMenu className="de-page-selector">
                    {selectOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`form-check-inline dropdown-item ${option.value}${option.subitem ? ' sub-item' : ''}`}
                            onClick={() => selectOnChange(option)}>
                            <Label className={`form-check-label`}>{option.label}</Label>
                        </div>

                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    );
}